import React from 'react';
import ReactApexCharts from 'react-apexcharts';
import PropTypes from 'prop-types';

function LineChartSeries({ labels, series, colors, isLoading }) {
  const options = {
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      categories: labels,
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm',
      },
    },
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors,
  };

  if (isLoading) {
    return (
      <div className="h-full w-full flex items-end space-x-3 p-4">
        <div className="animate-pulse bg-neutral-100 h-full w-full rounded" />
        <div className="animate-pulse bg-neutral-100 h-5/6 w-full rounded" />
        <div className="animate-pulse bg-neutral-100 h-3/6 w-full rounded" />
        <div className="animate-pulse bg-neutral-100 h-2/5 w-full rounded" />
        <div className="animate-pulse bg-neutral-100 h-1/6 w-full rounded" />
      </div>
    );
  }

  return (
    <ReactApexCharts
      height="100%"
      options={options}
      series={series}
      type="bar"
    />
  );
}
LineChartSeries.defaultProps = {
  labels: [],
  series: [],
  colors: [],
  isLoading: false,
};

LineChartSeries.propTypes = {
  labels: PropTypes.instanceOf(Array),
  series: PropTypes.instanceOf(Array),
  colors: PropTypes.instanceOf(Array),
  isLoading: PropTypes.bool,
};

export default LineChartSeries;
